<div class="current-estimate-version-block" *ngIf="currentEstimateVersion">
  <div class="estimate-note" *ngIf="(currentEstimateVersion.items ?? []).length > 0">
    <mat-form-field appearance="outline" class="textarea w-100" appFormFieldFilled [class.disabled]="readonly">
      <textarea matInput cdkTextareaAutosize
                cdkAutosizeMinRows="1"
                placeholder="Estimate Note"
                (focus)="this.noteFocused = true; this.currentNote = currentEstimateVersion.note ?? ''; editableInFocus.emit(true)"
                (focusout)="noteFocusout(currentEstimateVersion.id, currentEstimateVersion.note); editableInFocus.emit(false)"
                [(ngModel)]="currentEstimateVersion.note"
                [readonly]="readonly"
      ></textarea>
    </mat-form-field>
    <div class="note-border-bottom" [class.focused]="noteFocused"></div>
  </div>
  <app-estimate-items-list [estimateVersion]="currentEstimateVersion"
                           [estimate]="estimate"
                           [scrollPosition]="scrollPosition"
                           (itemsListFocus)="editableInFocus.emit($event)"
                           [readonly]="readonly"
  ></app-estimate-items-list>
</div>
